import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["item", "type", "onAppend"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { parseAlgoliaHitHighlight } from '@algolia/autocomplete-preset-algolia';
import React, { memo } from 'react';
import { AppendButton, ArrowIcon, Icon16, Icon24, ParentContainer, Query, QueryContainer, SearchItemContainer, SelectedMarker, Text, TextHighlighted } from './SearchItem.styles';
import AppendSvg from './assets/Append.svg';
import RecentSvg from './assets/Recent.svg';
import RightArrowSvg from './assets/RightArrow.svg';
import SearchSvg from './assets/Search.svg';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export let SearchItemType = /*#__PURE__*/function (SearchItemType) {
  SearchItemType["SEARCH"] = "search";
  SearchItemType["RECENT"] = "recent";
  return SearchItemType;
}({});
// Component to highlight inout query in suggestions
function Highlight(_ref) {
  let {
    hit,
    attribute
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    children: parseAlgoliaHitHighlight({
      hit,
      attribute
    }).map((_ref2, index) => {
      let {
        value,
        isHighlighted
      } = _ref2;
      if (isHighlighted) {
        return /*#__PURE__*/_jsxs(TextHighlighted, {
          children: [value, " "]
        }, index);
      }
      return value;
    })
  });
}
const MemoizedHighlight = /*#__PURE__*/memo(Highlight);
export function SearchItem(_ref3) {
  let {
      item,
      type,
      onAppend
    } = _ref3,
    autocompleteProps = _objectWithoutProperties(_ref3, _excluded);
  const icon = type === SearchItemType.SEARCH ? /*#__PURE__*/_jsx(Icon16, {
    src: SearchSvg,
    alt: type
  }) : /*#__PURE__*/_jsx(Icon16, {
    src: RecentSvg,
    alt: type
  });
  return /*#__PURE__*/_jsxs(ParentContainer, {
    children: [/*#__PURE__*/_jsxs(SearchItemContainer, _objectSpread(_objectSpread({
      className: "search-item-container"
    }, autocompleteProps), {}, {
      children: [/*#__PURE__*/_jsx(SelectedMarker, {
        className: "selected-marker"
      }), /*#__PURE__*/_jsxs(Query, {
        role: "button",
        type: "button",
        "aria-label": item.query,
        children: [/*#__PURE__*/_jsxs(QueryContainer, {
          "aria-hidden": "true",
          children: [icon, type === SearchItemType.SEARCH ? /*#__PURE__*/_jsx(MemoizedHighlight, {
            hit: item,
            attribute: "query"
          }) : /*#__PURE__*/_jsx(Text, {
            children: item.query
          })]
        }), /*#__PURE__*/_jsx(ArrowIcon, {
          className: "suggestion-arrow-icon",
          src: RightArrowSvg,
          alt: "select"
        })]
      })]
    })), /*#__PURE__*/_jsx(AppendButton, {
      className: "append-button",
      role: "button",
      type: "button",
      "aria-label": "Append query to search bar",
      onClick: () => onAppend(item),
      children: /*#__PURE__*/_jsx(Icon24, {
        src: AppendSvg,
        alt: "append"
      })
    })]
  });
}